import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Users, Star, DollarSign, Zap, Clock } from 'lucide-react';
const stats = [{
  icon: Users,
  value: '87+',
  label: 'Negocios Activos'
}, {
  icon: Star,
  value: '4.9 ⭐',
  label: 'Valoración Promedio'
}, {
  icon: DollarSign,
  value: '$24.99',
  label: 'Precio de Entrada'
}, {
  icon: Zap,
  value: '$0',
  label: 'Mensualidades'
}, {
  icon: Clock,
  value: '< 5 min',
  label: 'Tiempo de Entrega'
}];
export function SocialProofBar() {
  return <div className="w-full bg-[#080808] border-y border-white/5 py-5 overflow-hidden" data-id="element-298">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-5xl mx-auto px-4 flex flex-wrap items-center justify-center gap-y-4 gap-x-6 md:gap-x-10" data-id="element-299">
        {stats.map((stat, i) => <Fragment key={i} data-id="element-300">
            <div className="flex items-center gap-2.5" data-id="element-301">
              <div className="w-8 h-8 rounded-lg bg-cyan-500/10 flex items-center justify-center flex-shrink-0" data-id="element-302">
                <stat.icon className="w-4 h-4 text-cyan-400" data-id="element-303" />
              </div>
              <div data-id="element-304">
                <p className="text-white font-black text-base leading-none" data-id="element-305">
                  {stat.value}
                </p>
                <p className="text-gray-500 text-[11px] uppercase tracking-wider font-medium mt-0.5" data-id="element-306">
                  {stat.label}
                </p>
              </div>
            </div>
            {i < stats.length - 1 && <span className="hidden md:block text-white/10 text-xl select-none" data-id="element-307">
                |
              </span>}
          </Fragment>)}
      </motion.div>
    </div>;
}